import React, { useState } from 'react';
import './ActivityReportForm.css';

const ActivityReportForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    details: '',
    attachments: []
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      attachments: [...formData.attachments, ...files]
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // API integration will go here
    console.log('Form submitted:', formData);
    // Reset form after submission
    setFormData({
      title: '',
      details: '',
      attachments: []
    });
  };

  return (
    <div className="activity-report-container">
      <div className="header">
        <h1>Submit Activity Reports</h1>
        <p>Report your mobilization activities for admin review</p>
      </div>
      
      <form className="activity-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <h2>Activity Information</h2>
          
          <div className="form-group">
            <label htmlFor="title">Activity Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              placeholder="Enter activity title | e.g Community, Unity, Meeting, Rally, Vector Registration"
              value={formData.title}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="details">Activity Details *</label>
            <textarea
              id="details"
              name="details"
              placeholder="Describe the Mobilization activity in details...."
              value={formData.details}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
        </div>
        
        <div className="form-section">
          <h3>Attachments (Optional)</h3>
          <p className="attachment-info">Upload photos or videos from the activity (Max 10MB per file)</p>
          
          <div className="file-upload">
            <label htmlFor="file-upload" className="file-upload-label">
              Choose Photo/Video
            </label>
            <input
              type="file"
              id="file-upload"
              multiple
              onChange={handleFileChange}
              accept="image/*,video/*"
            />
          </div>
          
          {formData.attachments.length > 0 && (
            <div className="file-list">
              <p>Selected files:</p>
              <ul>
                {formData.attachments.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
        
        <div className="form-footer">
          <p>Reports are reviewed within 24-48 hours</p>
          <button type="submit" className="submit-button">Submit Activity Report</button>
        </div>
      </form>
    </div>
  );
};

export default ActivityReportForm;